import React from 'react';
import { observer, inject } from 'mobx-react';
// import ReactDOM from 'react-dom';
import style from './style.module.css';
import imgBasket from 'assets/blue_basket_x2.png'

@inject(store => {
    const { ifaceMngr, myShopApiStore } = store;
    return { ifaceMngr, myShopApiStore };
})

@observer
class Empty extends React.Component {
    render() {
        this.props.hideBasket();
        
        return (
            <div className={style.container}>
                <div id="" className={style.TopDiv}>
                    <div className={style.Desc}>אין לך הזמנות קודמות</div>
                    <button className={style.btn}
                    onClick={() => this.props.ifaceMngr.setActiveTopMenu('ShopMenu')} 
                    ><div className={style.btnDesc}>לחץ על הסל ובוא נתחיל</div>
                        <img className={style.imgBasket} src={imgBasket} alt="סל ריק"/>
                    </button>
                </div>
            </div>
        )
    }
}

export default Empty;